import { render, staticRenderFns } from "./WAChatArea.vue?vue&type=template&id=5f1d8dbf&scoped=true"
import script from "./WAChatArea.vue?vue&type=script&lang=js"
export * from "./WAChatArea.vue?vue&type=script&lang=js"
import style0 from "./WAChatArea.vue?vue&type=style&index=0&id=5f1d8dbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d8dbf",
  null
  
)

export default component.exports